import { useEffect } from "react";
import { useAuthentication } from "@repo/core";
import { useWebSocket } from "../hooks/useWebSocket";

/**
 * Component that manages WebSocket connection based on authentication state
 * Connects automatically when user is authenticated, disconnects when not
 */
export const WebSocketManager = () => {
  const { isAuthenticated, user } = useAuthentication();
  const { connect, disconnect, state } = useWebSocket();

  useEffect(() => {
    if (isAuthenticated && user) {
      console.log("🔐 User authenticated, connecting to WebSocket...");
      connect();
    } else if (!isAuthenticated && state !== "disconnected") {
      console.log("🔐 User not authenticated, disconnecting WebSocket...");
      disconnect();
    }
  }, [isAuthenticated, user, connect, disconnect, state]);

  // This component doesn't render anything visible
  return null;
};

export default WebSocketManager;
